import { useCallback, useEffect, useState } from 'react';
import { fetchTopMarkets } from '../api/markets';

const REFRESH_MS = 120_000;

export default function useTopMarkets() {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  const load = useCallback(async () => {
    try {
      const { items: nextItems } = await fetchTopMarkets();
      setItems(nextItems);
      setError('');
    } catch (err) {
      setError(err?.message || 'Failed to load top markets.');
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    load();
    const intervalId = window.setInterval(load, REFRESH_MS);
    return () => window.clearInterval(intervalId);
  }, [load]);

  return { items, loading, error, reload: load };
}
